import { Box } from '@mui/material';
import { useState } from 'react';

import slide1 from '../../assets/imgs/home/infuser-summary-all.png';
import slide2 from '../../assets/imgs/home/infuser_summary_1.png';
import slide3 from '../../assets/imgs/home/infuser_summary_2.png';
import slide4 from '../../assets/imgs/home/infuser_summary_3.png';
import slide5 from '../../assets/imgs/home/infuser_summary_4.png';

const images = [slide1, slide2, slide3, slide4, slide5];

export default function SlideImageCarousel() {
  const [index, setIndex] = useState(0);

  const handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const clickX = e.clientX - rect.left;

    if (clickX < rect.width / 2) {
      setIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
    } else {
      setIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      {/* 이미지 */}
      <Box
        onClick={handleClick}
        sx={{
          width: '360px',
          height: '200px',
          borderRadius: '12px',
          overflow: 'hidden',
          backgroundImage: `url(${images[index]})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          cursor: 'pointer',
        }}
      />

      {/* 이미지 바깥 아래쪽 도트 */}
      <Box
        sx={{
          mt: 1.5,
          display: 'flex',
          gap: '6px',
          justifyContent: 'center',
        }}
      >
        {images.map((_, i) => {
          const isActive = i === index;
          return (
            <Box
              key={i}
              sx={{
                width: isActive ? '20px' : '8px',
                height: '8px',
                borderRadius: isActive ? '9999px' : '50%',
                backgroundColor: isActive ? '#fff' : '#888',
                opacity: isActive ? 1 : 0.4,
                transition: 'all 0.2s ease',
              }}
            />
          );
        })}
      </Box>
    </Box>
  );
}
